var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "fabricJSContainer", attrs: { id: "fabric-js-container" } },
    [
      _c("canvas", {
        ref: "fabricJS",
        staticClass: "workspace-module-container",
        attrs: { id: "fabric-js-canvas" }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }